import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";

import { MessageBlockComponent } from "@hermes/aphrodite/message-block";

import { ProductLeadTimeComponent } from "./components/product-lead-time/product-lead-time.component";

@NgModule({
    imports: [CommonModule, MessageBlockComponent],
    declarations: [ProductLeadTimeComponent],
    exports: [ProductLeadTimeComponent],
    providers: [DatePipe],
})
export class ProductLeadTimeModule {}
